'use strict';
module.exports = function($) {
  var PlaceholderField, defaultPromptEnabled, inputEmpty, setPlaceholder;
  PlaceholderField = $.fn.PlaceholderField = function() {
    if (PlaceholderField.hasNativePlaceholderSupport()) {
      return this;
    }
    return this.each(function() {
      return PlaceholderField.initPlaceholder($(this));
    });
  };
  PlaceholderField.hasNativePlaceholderSupport = function() {
    return _.all([document.createElement('input'), document.createElement('textarea')], function(elem) {
      return elem.placeholder != null;
    });
  };
  inputEmpty = function($input) {
    return /^\s*$/.test($input.val());
  };
  PlaceholderField.initPlaceholder = function($input) {
    var focusin, focusout;
    focusin = function() {
      if (defaultPromptEnabled($input)) {
        return $input.val('').removeClass('prompting');
      }
    };
    (focusout = function() {
      if (inputEmpty($input)) {
        return setPlaceholder($input);
      }
    })();
    return $input.on({
      focusin: focusin,
      focusout: focusout
    });
  };
  setPlaceholder = function($input) {
    var ref;
    $input.addClass('prompting');
    return $input.val((ref = $input.attr('placeholder')) != null ? ref : $input.attr('title'));
  };
  defaultPromptEnabled = function($input) {
    var placeholder, sansWhitespace;
    sansWhitespace = function(val) {
      return val.replace(/\s/g, '');
    };
    placeholder = $input.attr('placeholder') || $input.attr('title') || '';
    return sansWhitespace($input.val()) === sansWhitespace(placeholder);
  };
  return PlaceholderField;
};

